export enum RequiredContractsPermission {
  ViewGeneratedContracts = 'view_generated_contracts',
  GenerateContract = 'generate_contract',
  AcceptContract = 'accept_contract',
  ManageMyCompany = 'manage_my_company',
}
